interface CardSkeletonProps {
  count?: number;
}

export const CardSkeleton = ({ count = 4 }: CardSkeletonProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {Array.from(Array(count).keys()).map((item) => (
        <div
          key={item}
          className="bg-white border border-neutral-400 rounded-lg p-4 animate-pulse"
        >
          {/* Title */}
          <div className="h-6 bg-neutral-300 rounded w-3/4 mb-3" />

          {/* Description lines */}
          <div className="space-y-2 mb-3">
            <div className="h-4 bg-neutral-200 rounded w-full" />
            <div className="h-4 bg-neutral-200 rounded w-5/6" />
          </div>

          {/* Tag/Badge */}
          <div className="h-6 bg-neutral-300 rounded w-24 mb-2" />

          {/* Additional info */}
          <div className="h-3 bg-neutral-200 rounded w-20 mt-2" />
        </div>
      ))}
    </div>
  );
};
